import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "icon is-medium clickAble right" }
const _hoisted_3 = { class: "panel-block form" }
const _hoisted_4 = { class: "field is-horizontal" }
const _hoisted_5 = { class: "field-body" }
const _hoisted_6 = {
  key: 0,
  id: "record-settings",
  class: "field"
}
const _hoisted_7 = { class: "control" }
const _hoisted_8 = { class: "field is-horizontal" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "buttons"
}
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = { class: "icon" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "field is-horizontal" }
const _hoisted_18 = { class: "field-label is-normal" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "field-body" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "field is-horizontal" }
const _hoisted_26 = { class: "field-label is-normal" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "field-body" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = { class: "control" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { class: "buttons" }
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "panel-heading",
      onClick: [
        _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isOpen = !_ctx.isOpen), ["stop"])),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.newVersion = false))
      ]
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.t("versiontitle")), 1),
      _createElementVNode("span", _hoisted_2, [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 0,
              icon: "chevron-up"
            }))
          : (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "chevron-down",
              size: "1x"
            }))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.t("currentversion")) + " ", 1),
                    (_ctx.versions.length && _ctx.currentVersion >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.visibleNWKVersion?.title || "") + " " + _toDisplayString(_ctx.t("versionfrom")) + _toDisplayString(_ctx.visibleNWKVersion?.date?.substring(8, 10) +
                    "." +
                    _ctx.visibleNWKVersion?.date?.substring(5, 7) +
                    "." +
                    _ctx.visibleNWKVersion?.date?.substring(0, 4)) + "  ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.isOpen)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "button is-small",
                          title: "Metadaten der Karte bearbeiten",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => {
                    _ctx.newVersion = true;
                    _ctx.editText = true;
                  })
                        }, [
                          _createElementVNode("span", _hoisted_10, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_11,
                  (!_ctx.newVersion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("button", {
                          class: "button",
                          onClick: [
                            _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addBlankNWK && _ctx.addBlankNWK(...args))),
                            _cache[4] || (_cache[4] = _withModifiers(($event: any) => ((_ctx.newVersion = true), (_ctx.firstCreation = true)), ["stop"]))
                          ]
                        }, [
                          _createElementVNode("span", _hoisted_13, [
                            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
                          ]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t("newemptyversion")), 1),
                          _hoisted_14
                        ]),
                        _createElementVNode("button", {
                          class: "button",
                          onClick: [
                            _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.duplicateNWK && _ctx.duplicateNWK(...args))),
                            _cache[6] || (_cache[6] = _withModifiers(($event: any) => ((_ctx.newVersion = true), (_ctx.firstCreation = true)), ["stop"]))
                          ]
                        }, [
                          _createElementVNode("span", _hoisted_15, [
                            _createVNode(_component_font_awesome_icon, { icon: "copy" })
                          ]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.t("duplicateversion")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.newVersion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("title")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "input",
                                  type: "text",
                                  placeholder: _ctx.t('titleplaceholder'),
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newVersionTitle) = $event))
                                }, null, 8, _hoisted_23), [
                                  [_vModelText, _ctx.newVersionTitle]
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("date")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "input",
                                  type: "date",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newVersionDate) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.newVersionDate]
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            class: "button is-primary",
                            onClick: [
                              _cache[9] || (_cache[9] = ($event: any) => (_ctx.addNewVersion())),
                              _cache[10] || (_cache[10] = _withModifiers(($event: any) => ((_ctx.newVersion = false), (_ctx.firstCreation = false)), ["stop"]))
                            ]
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t("save")), 1)
                          ]),
                          (_ctx.firstCreation)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button is-light",
                                onClick: [
                                  _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.deleteVersion && _ctx.deleteVersion(...args))),
                                  _cache[12] || (_cache[12] = _withModifiers(($event: any) => ((_ctx.newVersion = false), (_ctx.firstCreation = false)), ["stop"]))
                                ]
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t("cancel")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.firstCreation)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "button is-danger",
                                onClick: [
                                  _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deleteVersion && _ctx.deleteVersion(...args))),
                                  _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.newVersion = false), ["stop"]))
                                ],
                                disabled: _ctx.versions.length <= 1
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.t("deleteversion")), 1)
                              ], 8, _hoisted_33))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}